import { render, staticRenderFns } from "./DossierInput.vue?vue&type=template&id=75ef8c04&scoped=true&"
import script from "./DossierInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierInput.vue?vue&type=style&index=0&id=75ef8c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef8c04",
  null
  
)

export default component.exports